import localConfigFile from './config-local';

// const OUR_OWN_ORG_ID_ON_PROD = 98931;

const extractConfigFromWindowName = (windowName, availableKeys) =>
  windowName.split(';').reduce((acc, keyValuePair) => {
    const [key, value] = keyValuePair.split(':');
    if (availableKeys.includes(key)) {
      try {
        acc[key] = JSON.parse(value);
        console.log(`%cOverriding config ${key} with: ${acc[key]}`, 'color: magenta');
      } catch (e) {
        console.log(`%cFailed to override config ${key}`, 'color: crimson');
      }
    }

    return acc;
  }, {});

const chooseByDomain = (getslingUrl, toasttabUrl) => {
  if (typeof window !== 'undefined') {
    if (
      window &&
      (window.location.hostname.endsWith('.toasttab.com') ||
        window.location.hostname.endsWith('.toastteam.com'))
    ) {
      return toasttabUrl;
    }
  }

  return getslingUrl;
};

// TODO slowly get rid of this stuff by moving the configuration
// to the right environment in @sdk/config/appConfig and dropping it here;
// react/config/__tests__/getConfig.ts would help in the process
export const createConfig = ({
  isDevEnv = __DEV__,
  isStagingEnv = __STAGING__,
  useDevServer = __BUILD_FOR_DEV_SERVER__,
  localConfig = localConfigFile,
  windowName = name,
} = {}) => {
  const production = {
    ACH_CREDIT_TRANSFER_ENABLED_ORG_IDS: [60709, 109572, 112727],
    ADD_SICK_CALLOUT_BY_RANGE_ENABLED: true,
    ADMIN_SITE_URL: 'https://api.sling.is/admin/',
    AFTER_ONBOARDING_PATH: '/shifts',
    ALERTS_AUTO_CLOSE: {
      danger: 10000,
      default: 4000,
    },
    ALT_MONTH_VIEW_ENABLED: true,
    AMAZON_S3_BASE_URL: '//slinging.s3.amazonaws.com/',
    ANALYTICS_END_POINT: 'https://analytics.getsling.com',
    API_END_POINT: 'https://api.getsling.com/v1/',
    ARCHIVING_LOCATIONS_POSITIONS_ENABLED: true,
    ARTICLE_SEARCH_BY_PAGE_ENABLED: true,
    ARTICLE_SEARCH_ENABLED: true,
    AUTH_COOKIE_NAME: 'authorization-token',
    AUTOMATED_BREAKS_ATTESTATIONS_ENABLED: true,
    AUTOMATED_BREAKS_ENABLED: true,
    AUTOMATED_BREAKS_PREMIUM_PAY_ENABLED: true,
    AUTOSCHEDULING_ENABLED: [],
    CLOPENING_CONFLICT_ENABLED: true,
    CLOUDINARY_BASE_URL: '//res.cloudinary.com/gangverk/',
    COLLECT_FEEDBACK_URL:
      'https://script.google.com/macros/s/AKfycbzIKdar9lmslnZ2v30jhhv_S-Q7Map3ocINLI9v5ZH3HCTqzOpm/exec',
    CONSECUTIVE_WORK_DAYS_LIMIT_ENABLED: true,
    COOKIE_DOMAIN: 'getsling.com',
    COOKIE_EXPIRES_DAYS: 7,
    DEBUG_INFO_ENABLED: false,
    DELETING_PERSONAS_ENABLED: false,
    DISABLING_SCHEDULE_AUTOSYNC_ENABLED: [
      292658, 243505, 257606, 255040, 257663, 257673, 257576, 253847, 306423, 33366, 299702, 250235,
      184516, 261908, 265985, 397755, 441368, 547138, 632853,
    ],
    EXPORT_LOCATIONS_ENABLED: true,
    FORCE_SCHEDULE_AUTOSYNC_OFF: false,
    FREE_USER_LIMIT_ENABLED: true,
    GIPHY_API_KEY: 'p1JPpo2F6KnAoYQJScth01MeEURSfV06',
    GOOGLEMAPS_API_KEY: 'AIzaSyDHIKGQrYPpZARfLv3M6Wq1wr--WkcrNpU',
    GROUPED_EMAIL_NOTIFICATIONS_ENABLED: true,
    GUSTO_DASHBOARD: 'https://app.gusto.com/',
    HAPPINESS_SURVEY_ENABLED: true,
    SUBSCRIPTION_PREFERENCE_SURVEY_ENABLED: true,
    HEADLESS_BATCH_PRINT_URL: 'https://print.getsling.com/batchpdf',
    HEADLESS_PRINT_URL: 'https://print.getsling.com/pdf',
    HIDE_UNSCHEDULED_SHIFTS_SETTING_ENABLED: false,
    HTML_2_PDF_PRINTING_ENABLED: false,
    I18N_ENABLED: false,
    ICAL_RELEASE_DATE: new Date('2022-03-15'),
    INCLUDE_MEMORY_LEAKS_DIAGNOSTICS: false,
    INTERCOM_APP_ID: 'ztawwxuu',
    IS_STAGING: false,
    LABOR_UI_SCHEMA_VERSION: 13,
    LABOR_UI_SCHEMA_VERSION_FOR_SLING_ORG: 13,
    MANAGERS_ASSIGNED_TO_USERS_ENABLED: true,
    MARSHALING_WARNINGS_ENABLED: false,
    MEASURE_PERF: false,
    MOBILE_PHONE_POPUP_ENABLED: true,
    NPS_SURVEY_ENABLED: true,
    OFFER_50_PERCENT_DISCOUNT_ENABLED: true,
    OLD_TASKS_ENABLED: true,
    ONBOARDING_CHECKLIST_ENABLE_DEFINE_WAGES: true,
    ONBOARDING_CHECKLIST_ENABLED: true,
    ONBOARDINNG_SELECT_POS_ENABLED: true,
    ORG_ID_COOKIE_NAME: 'org-id',
    OT_COSTS_BANNER_ENABLED: true,
    PAUSE_SUBSCRIPTION_MENU_ITEM_ENABLED: true,
    PREMIUM_DISCOVERY_BACKOFF: 1000 * 10,
    PREMIUM_DISCOVERY_CHECK_INTERVAL: 1000 * 3600,
    PREMIUM_DISCOVERY_ENABLED: false,
    PREMIUM_DISCOVERY_STEPS_DELAY: 1000 * 3600 * 24,
    PRINT_BASE_PATH: 'https://app.getsling.com/',
    PRIVACY_POLICY_URL: 'https://getsling.com/privacy-policy/',
    PSAT_SURVEY_ENABLED: false,
    PTO_ON_PAYROLL_ENABLED: true,
    REACT_NEWSFEED_PAGE_ENABLED: false,
    REACT_SETTINGS_ENABLED: true,
    REDESIGNED_CLOCK_IN_MODAL_ENABLED: true,
    REFERRAL_PROGRAM_CODES: ['c3fb201a'],
    SCHEDULE_INTERVALS_IN_SETTINGS_ENABLED: false,
    SCHEDULED_SHIFT_IMPORT: true,
    SELECT_AUDIENCE_VISIBLE: false,
    SHIFT_ACCEPTANCE_ENABLED: true,
    SHIFT_CONFLICT_RESOLVING_ENABLED: true,
    SHIFT_TASK_ATTACHMENTS_ENABLED: true,
    SHIFT_TEMPLATES_ENABLED: true,
    SHIFT4_REFERRAL_PROGRAM_CODE: 'c3fb201a',
    SKIP_MARK_AS_READ: false,
    SLING_ADMIN_URL: 'https://admin.getsling.com/',
    SLING_APP_URL: 'https://app.getsling.com',
    SLING_FB_APP_ID: '361074924258479',
    SLING_INTEGRATIONS_URL: 'https://integrations.getsling.com',
    SLING_KIOSK_URL: 'https://kiosk.getsling.com',
    SLING_LOGIN_URL: 'https://login.getsling.com',
    SLING_URL: 'https://getsling.com',
    SPLIT_USER_PROFILE_ENABLED: true,
    START_PATH: '/',
    STRIPE_PUBLIC_KEY: 'pk_live_TkXZwwG9QNDk8o9gQp3Qs0aT',
    TERMS_OF_SERVICE_URL: 'https://getsling.com/terms-of-service/',
    TIME_CARD_NOTES_ENABLED: true,
    TIMEOFF_VISIBILITY_SETTING_ENABLED: true,
    TIMESHEET_CONSENT_FLOW_ENABLED: false,
    TOAST_LEARN_MORE_URL: 'https://support.getsling.com/en/articles/5041180-sling-and-toast',
    TOAST_SLING_CONNECT_URL: 'https://www.toasttab.com/restaurants/admin/scheduling/sling/connect',
    TOAST_URL: 'https://www.toasttab.com',
    TRANSLATIONS_ENABLED: false,
    TWEET_URL: 'https://twitter.com/intent/tweet',
    UNAVAILABILITY_LIST_V2_ENABLED: true,
    USE_EVENT_PROCESSOR_WORKER_EVENT_CACHE: true,
    USE_ORG_ID_IN_API_ROUTES: true,
    VERSION_AND_MAINTENANCE_CHECK_INTERVAL: 5 * 60 * 1000,
    WEBSOCKETS_END_POINT: 'https://socket.getsling.com/sockjs',
    WHATS_NEW_INTERVAL: 10 * 60 * 1000,
    WHATS_NEW_URL: '/wp-json/wp/v2/posts?categories=27',
    YEARLY_SUBSCRIPTIONS_ENABLED: true,
    TAX_CALCULATIONS_ENABLED: true,
    CHILI_PIPER_RELEASE_DATE: null,
    SENTRY_DSN: null,
    SERVER_SIDE_FILTERING_ENABLED: false
  };

  const staging = {
    ADMIN_SITE_URL: 'https://test-api.sling.is/admin/',
    AMAZON_S3_BASE_URL: '//slinging-staging.s3.amazonaws.com/',
    ANALYTICS_END_POINT: 'https://test-analytics.getsling.com',
    API_END_POINT: 'https://test-api.getsling.com/v1/',
    AUTH_COOKIE_NAME: 'staging:authorization-token',
    AUTOMATED_BREAKS_ENABLED: true,
    AUTOSCHEDULING_ENABLED: true,
    COOKIE_DOMAIN: chooseByDomain('getsling.com', 'scheduling-preprod.toasttab.com'),
    DEBUG_INFO_ENABLED: isDevEnv || __TEST__,
    DISABLING_SCHEDULE_AUTOSYNC_ENABLED: true,
    GUSTO_DASHBOARD: 'https://app.gusto-demo.com/',
    I18N_ENABLED: true,
    ICAL_RELEASE_DATE: new Date('2022-02-21'),
    INTERCOM_APP_ID: 'u53xmh01',
    IS_STAGING: true,
    MARSHALING_WARNINGS_ENABLED: true,
    MEASURE_PERF: true,
    ORG_ID_COOKIE_NAME: 'staging:org-id',
    OT_COSTS_BANNER_ENABLED: false,
    PREMIUM_DISCOVERY_CHECK_INTERVAL: 1000 * 60,
    PREMIUM_DISCOVERY_STEPS_DELAY: 1000 * 60 * 5,
    PRINT_BASE_PATH: chooseByDomain(
      'https://test-app.getsling.com/',
      'https://app.scheduling-preprod.toasttab.com/'
    ),
    REDESIGNED_CLOCK_IN_MODAL_ENABLED: true,
    REFERRAL_PROGRAM_CODES: ['36293e2b'],
    SELECT_AUDIENCE_VISIBLE: true,
    SCHEDULED_SHIFT_IMPORT: true,
    SHIFT_TASK_ATTACHMENTS_ENABLED: true,
    SHIFT4_REFERRAL_PROGRAM_CODE: '36293e2b',
    SLING_ADMIN_URL: 'https://test-admin.getsling.com/',
    SLING_APP_URL: chooseByDomain(
      'https://test-app.getsling.com',
      'https://app.scheduling-preprod.toasttab.com'
    ),
    SLING_INTEGRATIONS_URL: 'https://test-integrations.getsling.com',
    SLING_KIOSK_URL: 'https://test-kiosk.getsling.com',
    SLING_LOGIN_URL: chooseByDomain(
      'https://test-login.getsling.com',
      'https://login.scheduling-preprod.toasttab.com'
    ),
    SLING_URL: 'https://getsling.com',
    STRIPE_PUBLIC_KEY: 'pk_test_IdK3s21UK1FFVJZbSDA8DrnC',
    TOAST_SLING_CONNECT_URL:
      'https://preprod.eng.toasttab.com/restaurants/admin/scheduling/sling/connect',
    TOAST_URL: 'https://preprod.eng.toasttab.com',
    TRANSLATIONS_ENABLED: true,
    VERSION_AND_MAINTENANCE_CHECK_INTERVAL: 30 * 1000,
    WEBSOCKETS_END_POINT: 'https://test-socket.getsling.com/sockjs',
    WHATS_NEW_INTERVAL: 60 * 1000,
    WHATS_NEW_URL: '/wp-json/wp/v2/posts?categories=26',
    TAX_CALCULATIONS_ENABLED: true,
    CHILI_PIPER_RELEASE_DATE: new Date('2023-10-04'),
    SENTRY_DSN: 'https://7a6833c8aafa55b26d179058c747bee3@o15876.ingest.us.sentry.io/4507453825155072'
  };

  const develop = {
    AUTH_COOKIE_NAME: 'local:authorization-token',
    COOKIE_DOMAIN: chooseByDomain('getsling.com', 'eng.toastteam.com'),
    DEBUG_INFO_ENABLED: true,
    ORG_ID_COOKIE_NAME: 'local:org-id',
    API_END_POINT: chooseByDomain(
      'http://local-api.getsling.com:25691/v1/',
      'https://scheduling-dev-api.eng.toastteam.com/v1/'
    ),
    SLING_APP_URL: chooseByDomain(
      'http://local-app.getsling.com',
      'https://scheduling-dev-app.eng.toastteam.com'
    ),
    SLING_INTEGRATIONS_URL: 'http://local-integrations.getsling.com',
    SLING_KIOSK_URL: 'http://local-kiosk.getsling.com',
    SLING_LOGIN_URL: chooseByDomain(
      'http://local-login.getsling.com',
      'https://scheduling-dev-login.eng.toastteam.com'
    ),
    SENTRY_DSN: null,
    TOAST_URL: 'https://dev.eng.toastteam.com'
  };

  const devServerConfig = {
    AUTH_COOKIE_NAME: 'dev:authorization-token',
    SLING_APP_URL: 'https://dev-app.getsling.com',
    SLING_INTEGRATIONS_URL: 'https://integrations.getsling.com',
    COOKIE_DOMAIN: 'getsling.com',
    SLING_LOGIN_URL: 'https://dev-login.getsling.com',
    USE_ORG_ID_IN_API_ROUTES: false,
    USE_EVENT_PROCESSOR_WORKER_EVENT_CACHE: false,
  };

  const sourceConfigs = [production];
  if (isStagingEnv) {
    sourceConfigs.push(staging);

    if (isDevEnv) {
      sourceConfigs.push(develop);
    }
  }

  sourceConfigs.push(localConfig);

  if (isStagingEnv) {
    const override = extractConfigFromWindowName(windowName, Object.keys(production));
    sourceConfigs.push(override);
  }

  /**
   * Override config if deploying to https://dev.sling.is
   */
  if (useDevServer) {
    sourceConfigs.push(devServerConfig);
  }

  const config = Object.assign({}, ...sourceConfigs);

  // A-Z sort config object to better snapshot testing
  return Object.fromEntries(
    Object.entries(config).sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
  );
};

const config = createConfig();

export default config;
